import Vue from "vue";
import {VTooltip} from "v-tooltip";
import debounce from "lodash/debounce";
import dateFormatter from "../mixins/dateFormatter";
import AddManyContacts from "../components/AddManyContacts";
import ActionModal from "../components/ActionModal";
import ExportContacts from "../components/ExportContacts";
import EnrichGroupContacts from "../components/EnrichGroupContacts";
import GroupMembershipManagementTable from "../components/tables/GroupMembershipManagementTable";
import swal from "sweetalert2";
import { updateGroup } from "../utility/api/group/updateGroup";

Vue.component('edit-group-view', {
    mixins: [dateFormatter],
    components: { ExportContacts, GroupMembershipManagementTable, AddManyContacts, ActionModal, VTooltip, EnrichGroupContacts},
    data() {
        return {
            group: JSON.parse(this.vueGroup),
            memberCount: JSON.parse(this.vueGroup).counts.joined,
            vueAppErrors: [],
            clickToToggleMeta: { 'toggle': false, 'params': {} }
        }
    },
    methods: {
        clickToFilterMembers() {
            if(this.clickToToggleMeta.toggle === false) {
                this.clickToToggleMeta.toggle = true;
                this.clickToToggleMeta.params.status = 'member';
            }else{
                this.clickToToggleMeta.toggle = false;
            }
        },
        onGroupNameBlur(event) {
            const groupName = event.target.textContent.trim();
            if (groupName !== this.group.name) {
                this.saveGroupName(this.group.id, groupName);
            }
        },
        onUpdateGroupMemberCount(val) {
            this.memberCount += val;
        },
        saveGroupName: debounce((groupId, groupName) => {
            updateGroup(groupId, `name=${groupName}`).then(() => {
                $.notify("Saved Group Name", "success");
            }).catch((error) => {
                console.log(error);
                swal.fire({
                    title: 'Uh Oh!',
                    text: 'We had a problem saving the group name.',
                    type: 'error',
                    confirmButtonText: 'Ok',
                    buttonsStyling: false,
                    confirmButtonClass: 'btn btn-lg btn-primary'
                });
            });
        }, 2000)
    },
    props: {
        vueGroup: {
            type: String,
            required: true
        },
        vesselId: {
            type: Number,
            required: true
        }
    }
});
